import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { envAwarePost } from '../../util/util'

export const getPayoutSummary = createAsyncThunk(
	'getPayoutSummary',
	async ()=> await envAwarePost('api/financials/',{action:'getPayoutSummary'})
)

export const getPurchaseAvailabilites = createAsyncThunk(
	'getPurchaseAvailabilites',
	async ()=> await envAwarePost('api/financials/',{action:'getPurchaseAvailabilites'})
)

const slice = createSlice({
	name: 'sessions',
	initialState : {
		//no active tab specified at init. set this in the financials dashboard component
		//using the user
		activeTab:'',
		payouts:{
			status: 'init',
			availableBalance:0,
			pendingBalance:0,
			past90Total:0
		},
		//map from purchase item type to boolean
		//eg merchandise->true means that there are merchandise items to purchase
		purchaseAvailabilities:{
			status:'init',
			map:{}
		}
	},
	reducers : {
		setActiveTab : (state,action) => { state.activeTab = action.payload }
	},
	extraReducers : {
		[getPayoutSummary.pending] : (state)=>{ state.payouts.status = 'pending' },
		[getPayoutSummary.fulfilled] : (state,action)=>{
			state.payouts.status = 'idle'
			if (action.payload.success==='1') {
				state.payouts.availableBalance = action.payload.data.available_balance
				state.payouts.pendingBalance = action.payload.data.pending_balance
				state.payouts.past90Total = action.payload.data.past_90_total
			}
		},
		[getPurchaseAvailabilites.pending] : (state,action)=>{
			state.purchaseAvailabilities.status = 'pending'
		},
		[getPurchaseAvailabilites.fulfilled] : (state,action)=>{
			state.purchaseAvailabilities.status = 'idle'
			state.purchaseAvailabilities.map = action.payload.data.purchase_availabilities
		},
	}
})

export const {setActiveTab} = slice.actions

export default slice.reducer